import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import CategorySearchPage from '@features/admin/category-search/CategorySearchPage.tsx';
import { useCategorySearchStore } from '@features/admin/category-search/categorySearchStore';

const categorySearchSchema = z.object({
  query: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export const Route = createFileRoute('/admin/categories')({
  validateSearch: search => categorySearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: async ({ search }) => {
    const store = useCategorySearchStore.getState();
    await store.fetchCategories({
      query: search.query,
      page: search.page,
      size: search.size,
    });
  },
});

function RouteComponent() {
  return <CategorySearchPage />;
}
